// extracted by mini-css-extract-plugin
export default {"inputVRM":"InputVRM-module__inputVRM-kODQ","inputVRMWrapper":"InputVRM-module__inputVRMWrapper-uv8s"};